
import {debounceTime} from 'rxjs/operators';
/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import * as _ from 'lodash';

import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';

import { AppUtilityService } from '../../../core/services/app-utility.service';
import { ConfigService } from '../../../core/services/config.service';
import { LmsLoaderService } from '../../../core/services/lms-loader.service';
import { LmsModuleService } from '../../../core/services/lms-module.service';
import { LmsRendererService } from '../../../core/services/lms-renderer.service';
import { LocoDetail } from './../../../core/model/loco-detail.model';
import { MessageHandlerService } from '../../../core/services/message-handler.service';
import { Router } from '@angular/router';
import { TabSearchParameter } from '../../../core/model/tab-search-parameter.model';
import { TabService } from './../../../core/services/tab.service';
import { TerminalConfigService } from './../../shared/services/terminal-config.service';
import { TerminalHandlingOnTerminalDisplay } from './../../shared/model/terminal-handling-onterminal-display.model';

/**
 * @export
 * @class LmsTerminalOnTerminalListComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 */
@Component({
  selector: 'lms-terminal-on-terminal-list',
  templateUrl: './lms-terminal-on-terminal-list.component.html',
  styleUrls: ['./lms-terminal-on-terminal-list.component.scss']
})
export class LmsTerminalOnTerminalListComponent implements OnInit, OnChanges {

  totalLocoRecordCount = 0;
  serviceCtrShopRecordCount = 0;
  mainTrackRecordCount = 0;
  truckFuelRecordCount = 0;
  storageRecordCount = 0;
  nextAssignmentRecordCount = 0;
  totalLocoCountClass: string;
  serviceCenterCountClass: string;
  mainTrackCountClass: string;
  truckFuelCountClass: string;
  storageCountClass: string;
  nextAssignmentCountClass: string;
  @Input() totalOnTerminalLocomotivesArr: Array<TerminalHandlingOnTerminalDisplay>;
  @Input() terminalHandlingSearchText: string;
  totalSearchedOnTerminalLocomotiveArr: Array<TerminalHandlingOnTerminalDisplay> = [];
  onTerminalLocomotivesArr: any = [];
  scrollDivHeight: string;
  upperHeight = 314;
  selectedFilter: string;
  onTerminalFilterLabel: any;
  onTerminalTable: any;
  @Output() onLocoSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() showContextMenu: EventEmitter<any> = new EventEmitter<any>();
  @Output() hideLocoContextMenu: EventEmitter<boolean> = new EventEmitter<boolean>();
  isSearchApplied: boolean;
  rowsPerPage;
  rowHeight = 50;


  /**
   * Creates an instance of LmsTerminalOnTerminalListComponent.
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  constructor(private configService: ConfigService,
    private lmsModuleService: LmsModuleService,
    private terminalConfigService: TerminalConfigService,
    private router: Router,
    private lmsLoaderService: LmsLoaderService,
    private lmsRendererService: LmsRendererService,
    private tabService: TabService,
    private appUtilityService: AppUtilityService,
    private messageHandlerService: MessageHandlerService) {
    this.lmsRendererService.resizeObervable.pipe(debounceTime(10)).subscribe((isResize) => {
      if (isResize) {
      const newRowsPerPage = this.appUtilityService.getRowPerPageCount(111.6, this.upperHeight);
        if (newRowsPerPage !== this.rowsPerPage) {
        this.rowsPerPage = newRowsPerPage;
        this.resetDataScroller();
       }
      }
    });
  }

  /**
   * Initialize the state of lifecycle hook.
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  ngOnInit() {
    this.rowsPerPage = this.appUtilityService.getRowPerPageCount(97.2, this.upperHeight);
    this.onTerminalFilterLabel = this.terminalConfigService.terminalConfigData.subTypes.handling.onTerminal.filterLabel;
    this.onTerminalTable = this.terminalConfigService.terminalConfigData.subTypes.handling.onTerminal.table;
    this.selectedFilter = 'totalLoco';
    this.calculatePageHeight();
    if (this.totalOnTerminalLocomotivesArr) {
      this.setLocomotiveFilterCount(this.totalOnTerminalLocomotivesArr);

      // FIX: Ensure data is loaded for the default filter on initial load
    this.onTerminalLocomotivesArr = this.getTotalFilteredLocomotive(
      this.totalOnTerminalLocomotivesArr,
      this.selectedFilter
      );
    }
  }

  /**
   * Calculate page height for page level scroll.
   *
   * @private
   * @memberof LmsTerminalOnTerminalListComponent
   */
  private calculatePageHeight() {
    let heightToAdjust = 0;
    if (this.lmsRendererService.getWindowWidth() < 1280) {
      heightToAdjust = 27;
    }
    this.scrollDivHeight = (this.lmsRendererService.getWindowHeight() - this.upperHeight - heightToAdjust) + 'px';
  }

  /**
   * Invoked when state change in lifecycle hook.
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  ngOnChanges() {
    this.rowsPerPage = this.appUtilityService.getRowPerPageCount(97.2, this.upperHeight);
    if (this.terminalHandlingSearchText && this.terminalHandlingSearchText.length > 0) {
      this.setTotalSearchedOnTerminalTrainsArr(this.terminalHandlingSearchText, this.totalOnTerminalLocomotivesArr);
    } else {
      this.isSearchApplied = false;
      this.onTerminalLocomotivesArr = this.removeDuplicates(this.totalOnTerminalLocomotivesArr, 'previousAssignment');
      if (this.totalOnTerminalLocomotivesArr && this.onTerminalFilterLabel) {
        this.setLocomotiveFilterCount(this.totalOnTerminalLocomotivesArr);
      }
    }
    this.onTerminalLocomotivesArr = this.removeDuplicates(this.onTerminalLocomotivesArr, 'previousAssignment');
  }

  /**
   * Invoked when scroll is performed in terminal data scroller.
   * @param {any} event
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  loadOnTerminalLocomotivesLazy(event) {
    this.hideLocoContextPanel();
    let filteredLocomotiveArr = [];
    if (this.isSearchApplied) {
      filteredLocomotiveArr = this.getTotalFilteredLocomotive(this.totalSearchedOnTerminalLocomotiveArr, this.selectedFilter);
    } else {
      filteredLocomotiveArr = this.getTotalFilteredLocomotive(this.totalOnTerminalLocomotivesArr, this.selectedFilter);
    }
    filteredLocomotiveArr = this.removeDuplicates(filteredLocomotiveArr, 'previousAssignment');
    for (let i = event.first; i < filteredLocomotiveArr.length; i++) {
      if (this.onTerminalLocomotivesArr.indexOf(filteredLocomotiveArr[i]) < 0) {
        this.onTerminalLocomotivesArr.push(filteredLocomotiveArr[i]);
      }
    }
    this.onTerminalLocomotivesArr = this.removeDuplicates(this.onTerminalLocomotivesArr, 'previousAssignment');
  }

  /**
   * Reset data from data scroller.
   *
   * @memberof LmsTerminalOnTerminalListComponent
   */
  resetDataScroller() {
    let filteredLocomotiveArr = [];
    if (this.isSearchApplied) {
      filteredLocomotiveArr = this.getTotalFilteredLocomotive(this.totalSearchedOnTerminalLocomotiveArr, this.selectedFilter);
    } else {
      filteredLocomotiveArr = this.getTotalFilteredLocomotive(this.totalOnTerminalLocomotivesArr, this.selectedFilter);
    }
    filteredLocomotiveArr = this.removeDuplicates(filteredLocomotiveArr, 'previousAssignment');
    // Show all data, not just a page
    this.onTerminalLocomotivesArr = filteredLocomotiveArr;
  }

  /**
   * Invoked when filter is selected from top of the data scroller.
   * @param {string} filterName
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  setSelectedFilter(filterName: string) {
    this.selectedFilter = filterName;
    let filteredLocomotiveArr = [];
    if (this.isSearchApplied) {
      filteredLocomotiveArr = this.getTotalFilteredLocomotive(this.totalSearchedOnTerminalLocomotiveArr, this.selectedFilter);
    } else {
      filteredLocomotiveArr = this.getTotalFilteredLocomotive(this.totalOnTerminalLocomotivesArr, this.selectedFilter);
    }
    if (filteredLocomotiveArr && filteredLocomotiveArr.length > 0) {
      this.onTerminalLocomotivesArr = filteredLocomotiveArr;


      this.totalLocoCountClass = (filterName === 'totalLoco') ?
        'active' : ((this.totalLocoCountClass === 'disabled') ? 'disabled' : '');
      this.serviceCenterCountClass = (filterName === 'S') ?
        'active' : ((this.serviceCenterCountClass === 'disabled') ? 'disabled' : '');
      this.mainTrackCountClass = (filterName === 'M') ?
        'active' : ((this.mainTrackCountClass === 'disabled') ? 'disabled' : '');
      this.truckFuelCountClass = (filterName === 'T') ?
        'active' : ((this.truckFuelCountClass === 'disabled') ? 'disabled' : '');
      this.storageCountClass = (filterName === 'X') ?
        'active' : ((this.storageCountClass === 'disabled') ? 'disabled' : '');
      this.nextAssignmentCountClass = (filterName === 'nextAssignment') ?
        'active' : ((this.nextAssignmentCountClass === 'disabled') ? 'disabled' : '');

    }
  }

  /**
   * Method remove the dublicate object with respect to particular property.
   * @param {any} myArr
   * @param {any} prop
   * @returns
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  removeDuplicates(myArr, prop) {
    return _.uniqBy(myArr, prop);
  }

  /**
     * this method is used to navigate the user to locomotive screen
     * when click on locomotive id.
     * @param {string} subType
     * @param {string} type
     * @memberOf LmsTerminalOnTerminalListComponent
     */
  public showLocomotiveTabData(subType: string, type: string, locomotiveIdentifier: string) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: this.formatLocomotiveId(locomotiveIdentifier) });
    window.open(
      window.location.href.split('?')[0] + '?type='+ type.toLowerCase() +'&subtype=' + subType.toLowerCase() + '&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
  }

  /**
   * this method is used to navigate the user to train screen
   * @param {string} subType
   * @param {string} type
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  public showTrainTabData(subType: string, type: string, trainIdentifier: string) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: trainIdentifier });
    window.open(
      window.location.href.split('?')[0] + '?type='+ type.toLowerCase() +'&subtype=' + subType.toLowerCase() + '&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
  }

  /**
   * this method is used to navigate the user to terminal screen
   * @param {string} subType
   * @param {string} type
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  public showTerminalTabData(subType: string, type: string, terminalMnemonic: string) {
    const tabSearchParameter = <TabSearchParameter>({ searchText: terminalMnemonic });
    window.open(
      window.location.href.split('?')[0] + '?type='+ type.toLowerCase() +'&subtype=' + subType.toLowerCase() + '&search=' + tabSearchParameter.searchText,
      '_blank', "scrollbars=yes,resizable=yes,top=100,left=500,width=1000,height=800"
    );
  }

  /**
  * Format the locomotive id
  * @private
  * @param {string} value
  * @returns {string}
  * @memberOf LmsTerminalOnTerminalListComponent
  */
  private formatLocomotiveId(value: string): string {
    if (value) {
      value = value.trim();
      const v = value.match(/\d+/);
      if (v) {
        const locoInitial = (v.index <= 4) ? value.substring(0, v.index).trim() : value.substring(0, 4).trim();
        const locoNumber = (v.index <= 4) ? value.substring(v.index, value.length).trim() : value.substring(4, value.length).trim();
        return locoInitial + ' ' + locoNumber.replace(/^0+/, '');
      }
    }
  }

  /**
   * Get locomotive array as per filter applied.
   * @param {*} totalOnTerminalLocomotivesArr
   * @param {string} filterType
   * @returns {Array<TerminalHandlingOnTerminalDisplay>}
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  getTotalFilteredLocomotive(totalOnTerminalLocomotivesArr: any, filterType: string): Array<TerminalHandlingOnTerminalDisplay> {
    let filteredLocomotiveArray: Array<TerminalHandlingOnTerminalDisplay> = [];
    const temp = JSON.parse(JSON.stringify(totalOnTerminalLocomotivesArr));

    if (filterType === 'totalLoco') {
      filteredLocomotiveArray = [];
      filteredLocomotiveArray = temp.filter((totalOnTerminalTrains) => {
        const tempLocomotiveArr = totalOnTerminalTrains.locomotiveArr.filter((locomotive) => {
          return true;
        });
        if (tempLocomotiveArr && tempLocomotiveArr.length > 0) {
          totalOnTerminalTrains.locomotiveArr = tempLocomotiveArr;
          return true;
        }
      });
    } else if (filterType === 'nextAssignment') {
      filteredLocomotiveArray = [];
      filteredLocomotiveArray = temp.filter((totalInboundTrains) => {
        const tempLocomotiveArr = totalInboundTrains.locomotiveArr.filter((locomotive) => {
          return (locomotive.plannedAssignment);
        });
        if (tempLocomotiveArr && tempLocomotiveArr.length > 0) {
          totalInboundTrains.locomotiveArr = tempLocomotiveArr;
          return true;
        }
      });
    } else {
      filteredLocomotiveArray = [];
      filteredLocomotiveArray = temp.filter((totalInboundTrains) => {
        const tempLocomotiveArr = totalInboundTrains.locomotiveArr.filter((locomotive) => {
          return (locomotive.thpTypeCode === filterType);
        });
        if (tempLocomotiveArr && tempLocomotiveArr.length > 0) {
          totalInboundTrains.locomotiveArr = tempLocomotiveArr;
          return true;
        }
      });
    }
    return filteredLocomotiveArray;
  }

  /**
   * This shows Locomotive Context Menu
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  public showLocomotiveContextMenu(locomotiveIdentifier: string, actualLocomotiveId: string, index: string) {
    const loco: LocoDetail = {
      locomotiveIdentifier: locomotiveIdentifier,
      actualLocomotiveId: actualLocomotiveId
    };
    this.lmsLoaderService.showLoader();
    this.onLocoSelect.emit({ loco: loco, index: index });
  }

  public hideLocoContextPanel() {
    this.hideLocoContextMenu.emit(true);
  }

  /**
  * set count on filter for 'on terminal' section of terminal handling.
  * @private
  * @param {Array<TerminalHandlingInboundDisplay>} totalInboundTrainsArr
  * @memberOf LmsTerminalInboundListComponent
  */
  private setLocomotiveFilterCount(totalOnTerminalLocomotivesArr: Array<TerminalHandlingOnTerminalDisplay>) {
    if (this.onTerminalFilterLabel) {
      this.totalLocoRecordCount = totalOnTerminalLocomotivesArr.reduce(function (prevVal, elem) {
        return prevVal + elem.locomotiveArr.length;
      }, 0);

      const serviceCtrShopArray = this.getTotalFilteredLocomotive(totalOnTerminalLocomotivesArr, 'S');
      this.serviceCtrShopRecordCount = this.getLocomotiveCountFromArray(serviceCtrShopArray);

      const mainTrackArray = this.getTotalFilteredLocomotive(totalOnTerminalLocomotivesArr, 'M');
      this.mainTrackRecordCount = this.getLocomotiveCountFromArray(mainTrackArray);

      const truckFuelArray = this.getTotalFilteredLocomotive(totalOnTerminalLocomotivesArr, 'T');
      this.truckFuelRecordCount = this.getLocomotiveCountFromArray(truckFuelArray);

      const toStorageArray = this.getTotalFilteredLocomotive(totalOnTerminalLocomotivesArr, 'X');
      this.storageRecordCount = this.getLocomotiveCountFromArray(toStorageArray);

      const nextAssignmentArray = this.getTotalFilteredLocomotive(totalOnTerminalLocomotivesArr, 'nextAssignment');
      this.nextAssignmentRecordCount = this.getLocomotiveCountFromArray(nextAssignmentArray);

      this.totalLocoCountClass = (this.totalLocoRecordCount === 0) ? 'disabled' : 'active';
      this.serviceCenterCountClass = (this.serviceCtrShopRecordCount === 0) ? 'disabled' : '';
      this.mainTrackCountClass = (this.mainTrackRecordCount === 0) ? 'disabled' : '';
      this.truckFuelCountClass = (this.truckFuelRecordCount === 0) ? 'disabled' : '';
      this.storageCountClass = (this.storageRecordCount === 0) ? 'disabled' : '';
      this.nextAssignmentCountClass = (this.nextAssignmentRecordCount === 0) ? 'disabled' : '';
    }
  }
  /**
   * Count locomotive with in a array.
   *
   * @param {*} onTerminalLomotiveArr
   * @returns {number}
   *
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  getLocomotiveCountFromArray(onTerminalLomotiveArr: any): number {
    let locomotiveCount = 0;
    if (onTerminalLomotiveArr) {
      locomotiveCount = onTerminalLomotiveArr.reduce(function (prevVal, elem) {
        return prevVal + elem.locomotiveArr.length;
      }, 0);
    }
    return locomotiveCount;
  }

  /**
   * Redirect to train data or terminal status screen.
   *
   * @param {string} value
   *
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  redirectToTrainOrTerminal(value: string) {
    if (value) {
      if (this.isTrainId(value)) {
        this.showTrainTabData('Data', 'Train', value);
      } else {
        this.showTerminalTabData('Status', 'Terminal', value);
      }
    }
  }

  /**
   * Check for train id.
   *
   * @param {string} value
   * @returns {boolean}
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  isTrainId(value: string): boolean {
    let flag = false;
    if (value && value.length > 0) {
      if (!this.isNumeric(value.charAt(0))) {
        const remainingStr = value.substring(1, value.length);
        if (this.isNumeric(remainingStr)) {
          flag = true;
        }
      }
    }
    return flag;
  }
  /**
    * To check whether string is a number or not
    * @private
    * @param {string} value
    * @returns {boolean}
    * @memberOf LmsTerminalOnTerminalListComponent
    */
  private isNumeric(value: string): boolean {
    const v = value.match(/^\d+$/);
    if (v) {
      if (v.toString() === value) {
        return true;
      }
    }
    return false;
  }

  /**
   * Set on-terminal array through search parameter.
   * @private
   * @param {string} terminalHandlingSearchText
   * @param {Array<TerminalHandlingOnTerminalDisplay>} totalOnTerminalLocomotivesArr
   * @memberOf LmsTerminalOnTerminalListComponent
   */
  private setTotalSearchedOnTerminalTrainsArr(terminalHandlingSearchText: string,
    totalOnTerminalLocomotivesArr: Array<TerminalHandlingOnTerminalDisplay>) {
    this.totalSearchedOnTerminalLocomotiveArr = [];
    this.isSearchApplied = true;
    this.totalSearchedOnTerminalLocomotiveArr = totalOnTerminalLocomotivesArr.filter((terminalHandlingDisplay) => {
      return (terminalHandlingDisplay.previousAssignment === terminalHandlingSearchText);
    });

    for (let i = 0; i < totalOnTerminalLocomotivesArr.length; i++) {
      const locomotiveArr = [];
      for (let j = 0; j < totalOnTerminalLocomotivesArr[i].locomotiveArr.length; j++) {
        if (totalOnTerminalLocomotivesArr[i].locomotiveArr[j].locomotiveId &&
          totalOnTerminalLocomotivesArr[i].locomotiveArr[j].locomotiveId === terminalHandlingSearchText) {

          locomotiveArr.push(totalOnTerminalLocomotivesArr[i].locomotiveArr[j]);
        }
        if (totalOnTerminalLocomotivesArr[i].locomotiveArr[j].plannedAssignment &&
          totalOnTerminalLocomotivesArr[i].locomotiveArr[j].plannedAssignment === terminalHandlingSearchText) {

          locomotiveArr.push(totalOnTerminalLocomotivesArr[i].locomotiveArr[j]);
        }
      }
      if (locomotiveArr && locomotiveArr.length > 0) {
        const terminalHandlingDisplay = {
          previousAssignment: totalOnTerminalLocomotivesArr[i].previousAssignment,
          locomotiveArr: locomotiveArr
        };
        this.totalSearchedOnTerminalLocomotiveArr.push(terminalHandlingDisplay);
      }

    }

    this.totalSearchedOnTerminalLocomotiveArr = this.removeDuplicates(this.totalSearchedOnTerminalLocomotiveArr, 'previousAssignment');
    if (this.totalSearchedOnTerminalLocomotiveArr) {
      this.setLocomotiveFilterCount(this.totalSearchedOnTerminalLocomotiveArr);
      this.onTerminalLocomotivesArr = this.totalSearchedOnTerminalLocomotiveArr;
    }
  }

  /**
   * Redirect to tab according to type, subType and search text.
   * @param {string} type
   * @param {string} subType
   * @param {string} searchText
   * @memberof LmsTerminalOnTerminalListComponent
   */
  redirectToTab(type: string, subType: string, searchText: string) {
    this.appUtilityService.navigateByUrl(type, subType, searchText, true);
  }

  /**
   * Check value is terminal or not for displaying ETD.
   *
   * @param {string} value
   * @returns {boolean}
   * @memberof LmsTerminalOnTerminalListComponent
   */
  isEtdDisplay(value: string): boolean {
    let flag = true;
    if (value && this.appUtilityService.isValidTerminalId(value)) {
      flag = false;
    }
    return flag;
  }

  showContextMenuLinks(event, type: string, id: string, value: string) {
    let contextMenu;
    if (type) {
      if ('MIX' === type.toUpperCase()) {
        let typeTemp;
        if (this.isTrainId(value)) {
          typeTemp = 'Train';
        } else {
          typeTemp = 'Terminal';
        }
        contextMenu = {
          id: id,
          type: typeTemp,
          value: value,
          event: event
        };
      } else {
        contextMenu = {
          id: id,
          type: type,
          value: value,
          event: event
        };
      }
      this.showContextMenu.emit(contextMenu);
    }
  }
}
